module.exports = __webpack_public_path__ + "../resources/img/storebadge_de.b37fbda5.svg";